<template>
  <div class="main-container">
    <div class="text-container">
      <h1>
        Arthur KEUSCH
      </h1>
      <h2>
        Étudiant en Master IoT à l'UMLP
      </h2>
      <h3>
        UFR STGI, Graduate School EIPHI, Montbéliard
      </h3>
      <div class="card-container">
        <CardHome title="CV" content="Cliquez ici pour accéder à mon CV." to="/cv"/>
        <CardHome title="Portfolio" content="Cliquez ici pour accéder à mon Portfolio." to="/portfolio"/>
        <GitHubInfo username="arthurkeusch" style="cursor: auto;"/>
      </div>
    </div>
    <div class="photo-container">
      <div class="circle-wrapper">
        <img src="../../public/photo_moi_no_background.png" alt="Photo de profil"/>
      </div>
    </div>
  </div>
</template>

<script>
import CardHome from "@/components/CardHome.vue";
import GitHubInfo from "@/components/GitHubInfo.vue";

export default {
  components: {
    GitHubInfo,
    CardHome
  }
}
</script>

<style scoped>
h1 {
  font-size: 4rem;
  margin: 0 0 1rem 0;
}

h2 {
  font-size: 2rem;
  margin: 0;
}

h3 {
  font-size: 1rem;
  margin: 0 0 1rem 0;
}

.main-container {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  padding-inline: 1rem;
}

.photo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40%;
  min-width: 280px;
}

.circle-wrapper {
  width: 300px;
  aspect-ratio: 1;
  background: #323336;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  transition: transform 0.3s ease, filter 0.3s ease;
  filter: drop-shadow(0 0 10px transparent);
}

.circle-wrapper:hover {
  transform: translateY(-5px);
  filter: drop-shadow(0 0 30px #00f0ff);
}

.circle-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 40%;
  transform: scale(1.1);
}

.text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  padding: 2rem 0;
  box-sizing: border-box;
  text-align: center;
  width: 60%;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 1rem;
  margin-top: 2rem;
  padding-inline: 0;
  width: 100%;
  box-sizing: border-box;
}

.card-container > * {
  flex: 1 1 320px;
  display: flex;
}

@media (max-width: 900px) {
  .main-container {
    flex-direction: column-reverse;
    padding-inline: 0.75rem;
  }

  .photo-container {
    width: 100%;
    min-width: 0;
  }

  .text-container {
    width: 100%;
    min-height: auto;
    padding: 1.5rem 0.5rem;
  }

  .card-container {
    gap: 0.75rem;
    margin-top: 1.25rem;
    padding-inline: 0;
  }

  .card-container > * {
    flex: 1 1 100%;
    max-width: 100%;
  }
}
</style>
